import React from 'react';

const Norway = (props: { width: number }) => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Flag of Norway</title>
      <rect fill="#ba0c2f" height="16" width="22" />
      <g fill="#fff">
        <rect height="16" width="4" x="6" />
        <rect height="4" width="22" y="6" />
      </g>
      <g fill="#00205b">
        <rect height="16" width="2" x="7" />
        <rect height="2" width="22" y="7" />
      </g>
    </svg>
  );
};

export default Norway;
